import { Asterisk } from "lucide-react";

const ITEMS = [
  "Talent Recruitment",
  "Custom Software",
  "RPO",
  "ERPNext Implementation",
  "HR Advisory",
  "Business Automation",
  "Web & Mobile Apps",
  "IT Consulting",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="relative overflow-hidden border-y border-white/5 bg-[#050942]/60 py-7 select-none"
    >
      <div className="flex w-max animate-marquee items-center">
        {row.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center">
            <span
              className={`font-['Poppins'] text-2xl sm:text-3xl font-semibold tracking-tight px-8 ${
                i % 2 === 0 ? "text-white/90" : "stroke-text"
              }`}
            >
              {item}
            </span>
            <Asterisk size={22} className="text-[#F89335] shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
